import { z } from 'zod';
import { dateSchema } from '@/model/utils';

export class Classroom {
  constructor(
    public id: string,
    public userIds: string[],
    public schoolId: string,
    public name: string,
    public label?: string,
    public createdAt?: Date,
    public updatedAt?: Date,
    /**
     * @deprecated
     */
    public lessonIds?: string[],
    /**
     * @deprecated
     */
    public lessonActivateDates?: { [key: string]: Date }
  ) {}

  public static zodSchema = z.object({
    id: z.string(),
    userIds: z.array(z.string()),
    lessonIds: z.array(z.string()).optional(),
    schoolId: z.string(),
    lessonActivateDates: z.record(z.string(), dateSchema).optional(),
    name: z.string(),
    label: z.string().optional(),
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  });

  public static fromJson(json: unknown): Classroom {
    const validJson = this.check(json);
    const classroom = new Classroom(
      validJson.id,
      validJson.userIds,
      validJson.schoolId,
      validJson.name,
      validJson.label,
      validJson.createdAt,
      validJson.updatedAt,
      validJson.lessonIds,
      validJson.lessonActivateDates
    );
    return classroom;
  }

  public static fromJsonArray(jsonArray: unknown): Classroom[] {
    const validJsonArray = this.checkArray(jsonArray);
    return validJsonArray.map((json) => this.fromJson(json));
  }

  public static check(json: unknown): z.infer<typeof this.zodSchema> {
    const validJson = this.zodSchema.parse(json);
    return validJson;
  }

  public static checkArray(jsonArray: unknown): z.infer<typeof this.zodSchema>[] {
    return z.array(this.zodSchema).parse(jsonArray);
  }

  /**
   * Determine if the model is using ClassroomLesson system to store lesson data in the classroom
   * instead of lessonIds.
   * If this is true, lessonIds should either be undefined or has the length of 0
   */
  public shouldUseClassroomLessonSystem(): boolean {
    return !Array.isArray(this.lessonIds) || this.lessonIds.length <= 0;
  }
}

export interface ClassroomWithStudentCount extends Classroom {
  studentCount: number;
}
